/* BLACK NOVEMBER — product page (Quoted)
   Price per tee by bundle, real low-stock notice, toast and store credit.
   Showcase only: does not change real prices, cart or checkout.
   Money is formatted in the visitor's currency (Shopify Markets). */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-bn-config]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || cfg.currency || 'GBP';
  var locale = document.documentElement.lang || cfg.locale || 'en';
  var fmt;
  try { fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }); }
  catch (e) { fmt = new Intl.NumberFormat('en', { style: 'currency', currency: currency }); }
  function money(cents) { return fmt.format(Math.round(cents) / 100); }

  var form = document.getElementById(cfg.formId);
  var currentPrice = cfg.price; // cents, presentment currency

  /* ---------- prices that depend on the variant price (line, ladder, store credit) ---------- */
  function renderPctPrices() {
    document.querySelectorAll('[data-bn-pct]').forEach(function (el) {
      var pct = parseFloat(el.getAttribute('data-bn-pct'));
      if (!isNaN(pct)) el.textContent = money(currentPrice * pct / 100);
    });
    document.querySelectorAll('.product__info [data-store-credit], [data-store-credit].store-credit--pdp').forEach(function (box) {
      var pct = parseFloat(box.getAttribute('data-sc-pct'));
      var amt = box.querySelector('[data-sc-amount]');
      if (amt && !isNaN(pct)) amt.textContent = money(currentPrice * pct / 100);
    });
  }

  /* ---------- Bundle app (Kaching or similar): find selected bundle ---------- */
  function bundleRoot() {
    return document.querySelector('.kaching-bundles') ||
      document.querySelector('kaching-bundle') ||
      document.querySelector('[id*="kaching"]');
  }

  function bundleBars(root) {
    var bars = root.querySelectorAll('.kaching-bundles__bar');
    if (bars.length) return Array.prototype.slice.call(bars);
    return Array.prototype.slice.call(root.querySelectorAll('input[type="radio"]')).map(function (r) {
      return r.closest('label') || r.parentElement;
    });
  }

  function selectedIndex(bars) {
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      if (/--selected|is-selected|active/.test(b.className)) return i;
      var r = b.querySelector('input[type="radio"]');
      if (r && r.checked) return i;
    }
    return -1;
  }

  // Reads "Buy 3 - Get 1 Free" / "Buy 2 - Get 10% OFF" / "6 tees" from the bundle text
  function parseBar(bar) {
    var txt = (bar.innerText || bar.textContent || '').replace(/\s+/g, ' ');
    var buy = txt.match(/buy\s*(\d+)/i);
    var free = txt.match(/get\s*(\d+)\s*(?:free|gr[aá]tis)/i);
    var off = txt.match(/(\d+(?:[.,]\d+)?)\s*%\s*off/i);
    var qty = 0, pct = NaN;
    if (buy) {
      var b = parseInt(buy[1], 10), f = free ? parseInt(free[1], 10) : 0;
      qty = b + f;
      if (f) pct = b / qty * 100;
      else if (off) pct = 100 - parseFloat(off[1].replace(',', '.'));
      else pct = 100;
    } else {
      var n = txt.match(/(\d+)\s*(?:tees?|t-shirts?|shirts?|items?|pieces?|pcs|units?)/i);
      if (n) qty = parseInt(n[1], 10);
      if (off) pct = 100 - parseFloat(off[1].replace(',', '.'));
    }
    return { qty: qty, pct: pct };
  }

  var priceBox = document.querySelector('[data-bn-dyn]');
  var priceContainer = priceBox ? priceBox.closest('.product-meta__price-list-container') : null;

  function renderDynamic() {
    if (!cfg.dynamic || !priceBox) return;
    var root = bundleRoot();
    var info = null;
    if (root) {
      var bars = bundleBars(root);
      var idx = selectedIndex(bars);
      if (idx > -1) {
        var c = cfg.combos[idx] || {};
        var qty = parseInt(c.qty, 10) || 0;
        var pct = parseFloat(String(c.pct || '').replace(',', '.'));
        if (!qty || isNaN(pct)) {
          var parsed = parseBar(bars[idx]);
          if (!qty) qty = parsed.qty;
          if (isNaN(pct)) pct = parsed.pct;
        }
        if (qty > 1 && pct > 0 && pct < 100) info = { qty: qty, pct: pct };
      }
    }

    if (!info) { priceContainer.classList.remove('bn-dyn-active'); return; }

    var unit = currentPrice * info.pct / 100;
    var off = Math.round(100 - info.pct);
    priceBox.querySelector('[data-bn-dyn-unit]').textContent = money(unit);
    priceBox.querySelector('[data-bn-dyn-suffix]').textContent = cfg.dynSuffix || '';
    priceBox.querySelector('[data-bn-dyn-compare]').textContent = money(currentPrice);
    var badge = priceBox.querySelector('[data-bn-dyn-badge]');
    badge.textContent = '-' + off + '%';
    badge.hidden = off <= 0;
    var tot = priceBox.querySelector('[data-bn-dyn-total]');
    if (cfg.dynTotal) {
      tot.textContent = (cfg.dynTotalText || '{qty} tees for {total}')
        .replace(/\{qty\}/g, info.qty).replace(/\{total\}/g, money(unit * info.qty));
      tot.hidden = false;
    } else {
      tot.hidden = true;
    }
    priceContainer.classList.add('bn-dyn-active');
  }

  function watchBundles() {
    var root = bundleRoot();
    if (!root) return false;
    root.addEventListener('click', function () { setTimeout(renderDynamic, 60); });
    root.addEventListener('change', function () { setTimeout(renderDynamic, 60); });
    new MutationObserver(renderDynamic).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked'] });
    renderDynamic();
    return true;
  }

  if (cfg.dynamic && priceBox) {
    var tries = 0;
    (function wait() {
      if (watchBundles()) return;
      if (++tries < 40) setTimeout(wait, 250);
    })();
  }

  /* ---------- line + ladder: scroll to bundles (or to the add to cart button) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bn-scroll]');
    if (!t) return;
    var target = bundleRoot() || (form && form.querySelector('[type="submit"]'));
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ---------- Low stock (real Shopify inventory) ---------- */
  var sizeIdx = -1;
  (cfg.optionNames || []).forEach(function (n, i) {
    if (sizeIdx === -1 && /size|tamanho|taille|gr[oö]sse|talla/i.test(n)) sizeIdx = i;
  });

  function selectedOptions() {
    var sel = [];
    for (var i = 0; i < cfg.optionNames.length; i++) {
      var inp = document.querySelector('input[form="' + cfg.formId + '"][name="option' + (i + 1) + '"]:checked');
      sel.push(inp ? inp.value : null);
    }
    return sel;
  }

  function findVariant(opts) {
    for (var i = 0; i < cfg.variants.length; i++) {
      var v = cfg.variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  function isLow(v) { return v && v.managed && v.available && v.qty > 0 && v.qty <= cfg.stockThreshold; }

  var stockMsg = null;
  function renderStock(showMessage) {
    if (!cfg.stock || sizeIdx === -1) return;
    var inputs = document.querySelectorAll('input[form="' + cfg.formId + '"][name="option' + (sizeIdx + 1) + '"]');
    if (!inputs.length) return;
    var sel = selectedOptions();

    Array.prototype.forEach.call(inputs, function (inp) {
      var label = document.querySelector('label[for="' + inp.id + '"]');
      if (!label) return;
      var opts = sel.slice(); opts[sizeIdx] = inp.value;
      var pill = label.querySelector('.bn-low-pill');
      if (isLow(findVariant(opts)) && cfg.stockPill) {
        if (!pill) { pill = document.createElement('span'); pill.className = 'bn-low-pill'; label.appendChild(pill); }
        pill.textContent = cfg.stockPill;
        label.classList.add('bn-has-low');
      } else if (pill) {
        pill.remove(); label.classList.remove('bn-has-low');
      }
    });

    if (!stockMsg) {
      var wrap = inputs[0].closest('.block-swatch-list-wrapper') || inputs[0].closest('.product-form__option-selector') || inputs[0].parentElement;
      stockMsg = document.createElement('p');
      stockMsg.className = 'bn-stock-msg';
      stockMsg.hidden = true;
      wrap.insertAdjacentElement('afterend', stockMsg);
    }
    var current = findVariant(sel);
    if (showMessage && isLow(current) && cfg.stockText) {
      stockMsg.innerHTML = '';
      var dot = document.createElement('span'); dot.className = 'bn-stock-msg__dot';
      stockMsg.appendChild(dot);
      stockMsg.appendChild(document.createTextNode(cfg.stockText.replace(/\{qty\}|\{qtd\}/g, current.qty)));
      stockMsg.hidden = false;
    } else {
      stockMsg.hidden = true;
    }
  }

  if (cfg.stock) {
    renderStock(false);
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[form="' + cfg.formId + '"]')) {
        setTimeout(function () { renderStock(true); }, 30);
      }
    });
  }

  /* ---------- variant change ---------- */
  if (form) {
    form.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && typeof v.price === 'number') currentPrice = v.price;
      renderPctPrices();
      renderDynamic();
    });
  }

  /* ---------- Toast ---------- */
  var toast = document.querySelector('.bn-toast');
  if (toast) {
    var seen = false;
    try { seen = sessionStorage.getItem('bn-toast-seen') === '1'; } catch (e) {}
    if (!seen) {
      var delay = (parseFloat(toast.dataset.delay) || 4) * 1000;
      var duration = (parseFloat(toast.dataset.duration) || 6) * 1000;
      var hide = function () {
        toast.classList.remove('bn-toast--in');
        setTimeout(function () { toast.hidden = true; }, 400);
      };
      setTimeout(function () {
        toast.hidden = false;
        requestAnimationFrame(function () { toast.classList.add('bn-toast--in'); });
        try { sessionStorage.setItem('bn-toast-seen', '1'); } catch (e) {}
        setTimeout(hide, duration);
      }, delay);
      toast.querySelector('.bn-toast__close').addEventListener('click', hide);
    }
  }
})();
